import * as WebFont from "webfontloader";

WebFont.load({
    google: {
        families: ['Lato:300,400,400i,700,900:latin-ext', 'Oswald:400,700:latin-ext', 'Raleway:400,600,700,800:latin-ext']
    }
});